import { OptionPutCall } from './OptionPutCall';
import { PriceLimitMeasure } from './PriceLimitMeasure';
import { StrikePriceSettings } from './StrikePriceSettings';
export class OptionContract {
    constructor(groupContractID, strikeContractID, alias, strikeVersion, strikePrice, putCall) {
        this.GroupContractID = null;
        this.StrikeVersion = null;
        this.LowLimit = 0;
        this.HighLimit = 0;
        this.minLot = -1;
        this.maxLot = -1;
        this.maxLotInCash = -1;
        this.Description = null;
        this.ExtFields = {};
        this.TradeSessionStatusId = null;
        this.ExchangeSessionName = null;
        this.InstrumentTradableID = null;
        this.ISIN = '';
        this.TradingMode = null;
        this.GroupContractID = groupContractID;
        this.StrikeContractID = strikeContractID;
        this.Alias = alias;
        this.StrikeVersion = strikeVersion;
        this.StrikePrice = strikePrice;
        this.PutCall = putCall;
        this.PriceLimitMeasure = PriceLimitMeasure.DISABLE;
    }
    static MergeOptionContractGroup(ids, optionContractList) {
        if (!ids || !optionContractList) {
            return;
        }
        const idsContractID = ids.ContractID;
        const ocl = optionContractList.filter(function (oc) {
            return oc.GroupContractID === idsContractID;
        });
        for (let i = 0, len = ocl.length; i < len; i++) {
            const oc = ocl[i];
            let sps = ids.StrikePricesList.find((sp) => sp.StrikeVersion === oc.StrikeVersion && sp.StrikePrice === oc.StrikePrice);
            const isPut = oc.PutCall === OptionPutCall.OPTION_PUT_VANILLA;
            const isCall = oc.PutCall === OptionPutCall.OPTION_CALL_VANILLA;
            if (sps === undefined) {
                sps = new StrikePriceSettings(oc.StrikeVersion, oc.StrikePrice, isPut, isCall);
                ids.StrikePricesList.push(sps);
            }
            if (isPut) {
                sps.PutTicker = oc.Alias;
                sps.LowLimitPut = oc.LowLimit;
                sps.HighLimitPut = oc.HighLimit;
                sps.minLotPut = oc.minLot;
                sps.maxLotPut = oc.maxLot;
                sps.maxLotInCashPut = oc.maxLotInCash;
                sps.PriceLimitMeasurePut = oc.PriceLimitMeasure;
                sps.DescriptionPut = oc.Description;
                sps.ExtFieldsPut = oc.ExtFields;
                sps.PutEnabled = true;
                sps.TradeSessionStatusIdPut = oc.TradeSessionStatusId;
                sps.ExchangeSessionNamePut = oc.ExchangeSessionName;
                sps.ContractIdPut = oc.StrikeContractID;
                sps.InstrumentTradableIDPut = oc.InstrumentTradableID;
                sps.ISINPut = oc.ISIN;
                sps.TradingModePut = oc.TradingMode; // #115179
            }
            else {
                sps.CallTicker = oc.Alias;
                sps.LowLimitCall = oc.LowLimit;
                sps.HighLimitCall = oc.HighLimit;
                sps.minLotCall = oc.minLot;
                sps.maxLotCall = oc.maxLot;
                sps.maxLotInCashCall = oc.maxLotInCash;
                sps.PriceLimitMeasureCall = oc.PriceLimitMeasure;
                sps.DescriptionCall = oc.Description;
                sps.ExtFieldsCall = oc.ExtFields;
                sps.CallEnabled = true;
                sps.TradeSessionStatusIdCall = oc.TradeSessionStatusId;
                sps.ExchangeSessionNameCall = oc.ExchangeSessionName;
                sps.ContractIdCall = oc.StrikeContractID;
                sps.InstrumentTradableIDCall = oc.InstrumentTradableID;
                sps.ISINCall = oc.ISIN;
                sps.TradingModeCall = oc.TradingMode; // #115179
            }
        }
        ids.useAliasName = !!ocl.length;
    }
}
